

const DEFAULT_ROUTES = {
  BASE_URL: "/home",
  PROFILE: "/profile",
  PROJECT: "/projects",
  REPORT_PORTAL: "/report-portal",
  MODEL_CONFIGURATION: "/model-configuration",
  CONFIGURATION: "/configuration",
  USERS: "/users",
  ROLES: "/roles",
  TESTRUN_DETAILS: "/testrun-details",
  LOGIN: "/login",
  SIGNUP: "/signup",
  LOGOUT: "/logout",
  CHANGE_PASSWORD: "/changePassword",
  RESET_PASSWORD: "/reset-password",
  SET_PASSWORD: "/set-password",
  CREATE_USER: "/createUser",
  TEST_CASE_VIEW: "/testcaseview",
  ORGANIZATIONS: "/organizations",
  AI_COST_TRACKING: "/ai-cost-tracking",
  SUPER_ADMIN_CREDITS: "/super-admin-credits",
  PLAN_MANAGEMENT: "/plan-management",
  USAGE_BY_USER: "/usage-by-user",
  FEEDBACK: "/feedback",
  APPS: "/apps",
  USER_APPS: "/user-apps",
  TEST_GROUPS: "/test-groups",
  TEST_GROUP_DETAIL: "/test-group-detail",
  TEST_LAUNCH: "/test-launch",
  TEST_CASES: "/test-cases",
  VARIABLES_AND_ENVIRONMENT: "/variables-and-environment",
  PROJECT_SETTINGS: "/project-settings",
  PROJECT_NOTIFICATION_PREFS: "/project-notification",
  FILE_MANAGER: "/file-manager",
  AUTOMATION: "/automation",
  EXECUTION_REPLAY: "/execution-replay",
  AUTOMATION_STUDIO: "/automation-studio",
  AUTOMATION_STUDIO_NEW: "/automation-studio-new",
  AUTOMATION_NEW: "/automation_new",
  AI_GENERATOR: "/ai-generator",
  ROOT: "/",
  DOCS: "/docs",
  TERMS: "/terms",
  PRIVACY: "/privacy",
};

export default DEFAULT_ROUTES;
